import { DdsElement } from '../dds-hu-element'
import { ChoiceElementMixin } from './choiceElementMixin'
import { FeedbackMixin } from './feedbackMixin'
import { FocusableMixin } from './focusableMixin'
import { FormElementMixin } from './formElementMixin'
import { LabelableMixin } from './labelableMixin'
import { LabelPositionedMixin } from './labelPositionedMixin'
import { SizedMixin } from './sizedMixin'

export const LabeledChoiceElement = FeedbackMixin(
  LabelPositionedMixin(
    ChoiceElementMixin(
      FocusableMixin(LabelableMixin(SizedMixin(FormElementMixin(DdsElement)))),
    ),
  ),
)
